import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

const easeOut = [0.22, 1, 0.36, 1];

const FeatureCard = ({ feature, index, onClick, reduceMotion }) => {
  const Icon = feature.icon;
  const className = `feature-card${feature.featured ? ' feature-card--featured' : ''}`;

  if (reduceMotion) {
    return (
      <button type="button" className={className} onClick={onClick}>
        {feature.featured && <span className="feature-badge">Start here</span>}
        <div className="feature-icon-wrapper">
          <Icon size={28} strokeWidth={1.75} />
        </div>
        <h3>{feature.title}</h3>
        <p>{feature.description}</p>
        <span className="card-arrow">
          Open <ChevronRight size={18} />
        </span>
      </button>
    );
  }

  return (
    <motion.button
      type="button"
      className={className}
      onClick={onClick}
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-48px' }}
      transition={{ duration: 0.55, delay: index * 0.07, ease: easeOut }}
      whileHover={{
        y: -14,
        scale: 1.025,
        transition: { type: 'spring', stiffness: 380, damping: 20 },
      }}
      whileTap={{ scale: 0.985, y: -4 }}
    >
      {feature.featured && <span className="feature-badge">Start here</span>}
      <motion.div
        className="feature-icon-wrapper"
        whileHover={{ rotate: 8, scale: 1.12 }}
        transition={{ type: 'spring', stiffness: 400, damping: 14 }}
      >
        <Icon size={28} strokeWidth={1.75} />
      </motion.div>
      <h3>{feature.title}</h3>
      <p>{feature.description}</p>
      <span className="card-arrow">
        Open <ChevronRight size={18} className="card-arrow-icon" />
      </span>
    </motion.button>
  );
};

export default FeatureCard;
